/**
 * v1.4.1.1 — PasswordInput reutilizable con toggle mostrar/ocultar (ojito).
 *
 * Renderiza sólo el <input> (+ botón ojito); el caller provee su propio
 * <label>/<Field>, consistente con los forms de auth y el modal de usuarios.
 * `onChange` emite el string directo (no el evento) para minimizar fricción.
 */
import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export function PasswordInput({
  value,
  onChange,
  name,
  id,
  placeholder,
  autoComplete = 'current-password',
  required,
  minLength,
  error,
  initialShow = false,
}: {
  value: string;
  onChange: (value: string) => void;
  name?: string;
  id?: string;
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
  error?: string | null;
  /** Arranca con la contraseña visible (p.ej. cuando un admin la asigna y comparte). */
  initialShow?: boolean;
}) {
  const [show, setShow] = useState(initialShow);
  return (
    <div>
      <div className="relative">
        <input
          className="input pr-10"
          type={show ? 'text' : 'password'}
          value={value}
          name={name}
          id={id}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          minLength={minLength}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShow((s) => !s)}
          aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          className="absolute inset-y-0 right-0 grid w-10 place-items-center text-slate-400 hover:text-slate-700"
        >
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
      {error && <span className="mt-1 block text-[11px] text-rose-600">{error}</span>}
    </div>
  );
}

export default PasswordInput;
